import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {ChooseDoctorComponent} from "./choose-doctor.component";

const routes: Routes = [
  {
    path: '',
    component: ChooseDoctorComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChooseDoctorRoutingModule {}
